module.exports = __webpack_public_path__ + "img/CA_thumb.7a6a50f5.png";